// 移动官网api地址
// 暴露接口需要用到的地址
// 接口配置config
let protocol = '';
let name = '';
let suffix = '';
if (process.env.NODE_ENV === 'production') {
  // 生产环境
  protocol = 'https:';
  name = 'dingdangyou';
  suffix = 'cn';
} else {
  // 开发环境
  // protocol = 'http:';
  // name = 'gamehl';
  // suffix = 'my';
  protocol = 'https:';
  name = 'dingdangyou';
  suffix = 'cn';
}
/* 设备上报 */
const device = `${protocol}//webapi.${name}.${suffix}/api/v1/init/device`
/* tab首页页面相关 */
const home = `${protocol}//webapi.${name}.${suffix}/api/v1/web/home`
const search = `${protocol}//webapi.${name}.${suffix}/api/v1/web/search`
const gameMore = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/more`
const gameH5 = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/h5`
const typesList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/type`
const classifyList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/type/list`
const gameRank = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/rank`
const gameDetail = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/detail`
const strategyDetail = `${protocol}//webapi.${name}.${suffix}/api/v1/web/strategy/detail`
const strategyList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/strategy/list`
/* tab活动页面相关 */
const activityList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/activity/list`
const activityDetail = `${protocol}//webapi.${name}.${suffix}/api/v1/web/activity/detail`
/* tab折扣或热门页面相关 */
const discount_hot = `${protocol}//webapi.${name}.${suffix}/api/v1/web/discount/list`
/* tab礼包页面相关 */
const giftList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/gift/list`
const giftTypeList = `${protocol}//webapi.${name}.${suffix}/api/v1/web/gift/type/list`
const giftDetail = `${protocol}//webapi.${name}.${suffix}/api/v1/web/gift/detail`
const giftGet = `${protocol}//webapi.${name}.${suffix}/api/v1/web/gift/get`
/* tab我的页面相关 */
const mine = `${protocol}//webapi.${name}.${suffix}/api/v1/user/home`
const modifyNick = `${protocol}//webapi.${name}.${suffix}/api/v1/user/modify_nick`
const playedGame = `${protocol}//webapi.${name}.${suffix}/api/v1/user/played_game`

const gameBalance = `${protocol}//webapi.${name}.${suffix}/api/v1/user/game_balance`
const balanceGame = `${protocol}//webapi.${name}.${suffix}/api/v1/user/balance_game`
const balanceUser = `${protocol}//webapi.${name}.${suffix}/api/v1/user/balance_user`

const payGame = `${protocol}//webapi.${name}.${suffix}/api/v1/user/pay_game`
const payUser = `${protocol}//webapi.${name}.${suffix}/api/v1/user/pay_user`
const payRecord = `${protocol}//webapi.${name}.${suffix}/api/v1/user/pay_record`

const gotGift = `${protocol}//webapi.${name}.${suffix}/api/v1/user/got_gift`

const service = `${protocol}//webapi.${name}.${suffix}/api/v1/user/service`

const idAuth = `${protocol}//webapi.${name}.${suffix}/api/v1/user/id_auth`
const modifyPwd = `${protocol}//webapi.${name}.${suffix}/api/v1/user/modify_pwd`
const news = `${protocol}//webapi.${name}.${suffix}/api/v1/user/news`
const newDetail = `${protocol}//webapi.${name}.${suffix}/api/v1/user/new_detail`
const newsPush = `${protocol}//webapi.${name}.${suffix}/api/v1/user/news_push`

/* 平台币充值 */
const platformRecharge = `${protocol}//webapi.${name}.${suffix}/api/v1/user/userAccount`
// const platformPay = `http://webapi.gamehl.my/api/v1/user/recharge`
const platformPay = `${protocol}//webapi.${name}.${suffix}/api/v1/user/recharge`

/* 绑定IOS归属 */
const bindIos = `${protocol}//webapi.${name}.${suffix}/api/v1/user/bind_ios`


/* 登录,注册,找回密码相关 */
const mobileReg = `${protocol}//webapi.${name}.${suffix}/api/v1/account/mobile_reg`
const forgetPwd = `${protocol}//webapi.${name}.${suffix}/api/v1/account/forget_pwd`
const pwdLogin = `${protocol}//webapi.${name}.${suffix}/api/v1/account/pwd_login`
const codeLogin = `${protocol}//webapi.${name}.${suffix}/api/v1/account/code_login`
/* 发送验证码相关 */
const sendCode = `${protocol}//webapi.${name}.${suffix}/api/v1/common/send_code`
/* 更新游戏下载量 */
const download = `${protocol}//webapi.${name}.${suffix}/api/v1/web/game/download`

export default {
  device,
  home,
  search,
  gameMore,
  gameH5,
  typesList,
  classifyList,
  gameRank,
  gameDetail,
  strategyDetail,
  strategyList,
  activityList,
  activityDetail,
  discount_hot,
  giftList,
  giftTypeList,
  giftDetail,
  giftGet,
  mobileReg,
  sendCode,
  forgetPwd,
  pwdLogin,
  codeLogin,
  mine,
  modifyNick,
  playedGame,
  gameBalance,
  balanceGame,
  balanceUser,
  payGame,
  payUser,
  payRecord,
  idAuth,
  modifyPwd,
  news,
  newDetail,
  gotGift,
  service,
  newsPush,
  download,
  bindIos,
  platformRecharge,
  platformPay,
}